import graphqlService from "@/services/graphql.service";
import { buildQuery } from "@/graphql/builders/query.builder";
import { userQueryTypeMap } from "@/graphql/type_maps/type.maps";
import { fragmentUserTariffState } from "@/graphql/fragments/query/tariffs.fragments";

async function fetchUserTariffState({ current = true, id } = {}) {
    const variables = id ? { id } : { current };

    const { query } = buildQuery({
        fragment: fragmentUserTariffState,
        field: "users",
        variables,
        typeMap: userQueryTypeMap,
    });

    const data = await graphqlService.requestGraphql({ query, variables });
    return Array.isArray(data?.users) ? data.users[0] : undefined;
}

export default { fetchUserTariffState };
